export default __webpack_public_path__ + "static/media/moota.1ce9a4f4.svg";